import 'regenerator-runtime/runtime';
import '@meterup/atto/src/styles/fonts.css';
import './sentry';

import { enableMapSet } from 'immer';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

enableMapSet();

declare global {
  interface Navigator {
    msSaveOrOpenBlob(blob: any, defaultName?: string): boolean;
  }
}

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
